export enum TransformersStatus {
    Pending = 1,
    Complete = 2,
    Assigned = 4,
    Rejected = 5,
    Retagged = 6,
}
